// extracted by mini-css-extract-plugin
export default {"feedback-button":"feedback-button","feedbackButton":"feedback-button","feedback-modal":"feedback-modal","feedbackModal":"feedback-modal"};